/* eslint-disable array-callback-return */
import { Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDataProvider, useNotify, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import BonusDollarBlueImage from '../assets/paid-blue-24-dp-1.svg';
import BonusDollarGreenImage from '../assets/paid-green-24-dp-1.svg';
import { getStartOfCurrentYear, getTodaysDate } from '../utils/Constants/ConstantData';
import { NUMBER } from '../utils/Constants/MagicNumber';

const BonusDetails =({identity}) =>{
    const dataProvider = useDataProvider();
    const today = moment(getTodaysDate()).format('YYYY-MM-DD');
    const notifiy = useNotify();
    const [response, setResponse] = useState({pendingBonus:{data:[],total:NUMBER.ZERO},paidBonus:{data:[],total:NUMBER.ZERO}});
    const [paidPeriods, setPaidPeriods] = useState({data:[], total:NUMBER.ZERO});
    const isStatements = identity?.company?.allow_bonus_statement_config;
    const resource = isStatements ? 'ProtivEmployeeBonusStatement__Dashboard' :'Attendance__BonusDashboard';
    const pendingFilter = isStatements ? {status: { _eq: 'pending' }}: { type: { _eq: 'is_performance_bonus' }, status: { _eq: 'pending' } };
    const paidFilter = isStatements ? {status: { _eq: 'paid' }}: { type: { _eq: 'is_performance_bonus' }, status: { _eq: 'paid' } };
    const totalKey  = isStatements ? 'total_earning':'bonus_earning';
    const customHeading =isStatements  ? 'Statements': 'Bonuses';
    useEffect(() => {
        const dashboardApiCalls = async () => {
            try {
                const allPaidPeriods = await dataProvider.getList('Period__DropdownList', { pagination: { page: NUMBER.ONE, perPage: NUMBER.THREE },
                                            filter: { start_date: { _lte: today } }, sort: { field: 'id', order: 'DESC' } });
                setPaidPeriods(allPaidPeriods);
            } catch (error) {
                notifiy('Something went wrong in paid periods Api.');
            }
        }
        dashboardApiCalls();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataProvider, notifiy]);

    const currentPayrollStart = moment(paidPeriods?.data?.length && paidPeriods?.data[NUMBER.ZERO]?.start_date).format('YYYY-MM-DD');
    const currentPayrollEnd = moment(paidPeriods?.data?.length && paidPeriods?.data[NUMBER.ZERO]?.end_date).format('YYYY-MM-DD');

    const previousPayrollStart = moment(paidPeriods?.data?.length && paidPeriods?.data[NUMBER.ONE]?.start_date).format('YYYY-MM-DD');
    const previousPayrollEnd = moment(paidPeriods?.data?.length && paidPeriods?.data[NUMBER.ONE]?.end_date).format('YYYY-MM-DD');

    const currentYear = moment(getStartOfCurrentYear()).format('YYYY-MM-DD');

    const navigate = useNavigate();
    const translate = useTranslate()
    const [filterval, setFilterval] = useState('all');
    const [filter, setFilter] = useState<any>(paidFilter);

    const handleChange = (event: SelectChangeEvent, eventName) => {
        switch (eventName.props.children) {
            case 'Current Payroll':
                    setFilter((previous) => ({ ...previous, paid_period_id_obj: { start_date: { _gte: currentPayrollStart }, end_date: { _lte: currentPayrollEnd } } }));
                    break;
            case 'Previous Payroll':
                    setFilter((previous) => ({ ...previous, paid_period_id_obj: { start_date: { _gte: previousPayrollStart }, end_date: { _lte: previousPayrollEnd } } }));
                    break;
            case 'Current Year':
                    setFilter((previous) => ({ ...previous, paid_period_id_obj: { start_date: { _gte: event.target.value } } }));
                    break;
            default:
                isStatements ? setFilter({status: { _eq: 'paid' }}): setFilter({ type: { _eq: 'is_performance_bonus' }, status: { _eq: 'paid' } });
                break;
        }
        setFilterval(event.target.value);
    };

    useEffect(() => {
        const pendingBonusApiCall = async () => {
            const paidBonus = await dataProvider.getList(resource, {
                pagination: { page: NUMBER.ONE, perPage: NUMBER.TEN_THOUSAND },
                sort: { field: 'id', order: 'DESC' }, filter: filter
            });
            setResponse((previous) => ({ ...previous, paidBonus: { data: paidBonus?.data, total: paidBonus?.total } }));
        }
        pendingBonusApiCall();
    }, [dataProvider, filter]);

    useEffect(() => {
        const pendingBonusApicall = async () => {
            const pendingBonus = await dataProvider.getList(resource, {
                pagination: { page: NUMBER.ONE, perPage: NUMBER.TEN_THOUSAND },
                sort: { field: 'id', order: 'ASC' }, filter: pendingFilter
            });
            setResponse((previous) => ({ ...previous, pendingBonus: { data: pendingBonus?.data, total: pendingBonus?.total } }));
        }
        pendingBonusApicall();
    }, [dataProvider,isStatements]);

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const calculateBonuses = (data) => {
        return data.reduce((acc, paidValue) => {
            return acc + paidValue[totalKey];
        }, NUMBER.ZERO);
    };

    const pendingBonus = response?.pendingBonus?.data && calculateBonuses(response?.pendingBonus?.data);
    const paidBonus = response?.paidBonus?.data && calculateBonuses(response?.paidBonus?.data);

    const pendingBonusCount = response?.pendingBonus?.total;

    const formattedPendingBonus = formatter.format(pendingBonus);
    const formattedPaidBonus = formatter.format(paidBonus);


    return (
        <>
            <Grid item xs={12} sm={4} md={4} lg={4} className='dash-first-bonus-grid grid-item-boxes'>
                <div className='bonus-pool-box'>
                    <Box className='dashboard-card-top-head'>
                        <div className='dashboard-card-left-head'>
                            <Typography variant='h3'>Bonuses</Typography>
                        </div>
                        <div className='dashboard-card-right-head'>
                            <Box sx={{ minWidth: 120 }}>
                                <FormControl fullWidth className='no-translate'>
                                    <Select
                                        labelId='demo-simple-select-helper-label'
                                        id='demo-simple-select-helper'
                                        value={filterval}
                                        onChange={handleChange}
                                        MenuProps={{ disableScrollLock: true }}
                                    >
                                        <MenuItem value={'all'} className='no-translate'>All</MenuItem>
                                        <MenuItem value={`${currentPayrollStart}_curr`} selected className='no-translate'>Current Payroll</MenuItem>
                                        <MenuItem value={`${previousPayrollStart}_prev`} className='no-translate'>Previous Payroll</MenuItem>
                                        <MenuItem value={currentYear} className='no-translate'>Current Year</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </div>
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <div className='dash-bonus-panel'>
                                <div className='bonus-dollar-icon'><img src={BonusDollarBlueImage} alt='Dollar' /></div>
                                <div className='dash-bonus-panel-left'>
                                    <Typography variant='h4'><strong>{response?.pendingBonus?.total > NUMBER.ZERO ? formattedPendingBonus : formatter.format(pendingBonus)}</strong></Typography>
                                    <Typography variant='subtitle2'>Pending {customHeading} <span className='bonus-panel-link' onClick={() => navigate(isStatements ? '/protivEmployeeBonusStatement':'/propay/payroll/attendances')}>
                                        {(pendingBonusCount > NUMBER.ONE ? `(${pendingBonusCount} ${customHeading})` : `(${pendingBonusCount} ${isStatements ? 'Statement':'Bonus'})`)}</span></Typography>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div className='dash-bonus-panel dash-bonus-green-panel'>
                                <div className='bonus-dollar-icon'><img src={BonusDollarGreenImage} alt='Dollar' /></div>
                                <div className='dash-bonus-panel-left'>
                                    <Typography variant='h4'><strong>{response?.paidBonus?.total > NUMBER.ZERO ? formattedPaidBonus : formatter.format(paidBonus)}</strong></Typography>
                                    <Typography variant='subtitle2'>Paid {customHeading}</Typography>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </>
    );
};
export default BonusDetails;
